import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Button, Col } from 'reactstrap';
import { baseURL } from '../../_helpers';
import * as moment from 'moment';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'
import { TOKEN } from '../../_helpers/token';
import { Link } from 'react-router-dom';
import Select from "react-select";


export class Secure_d extends React.Component {
    constructor(props) {
        super(props);
        this.applyCallback = this.applyCallback.bind(this);


        this.columns = [
            {
                key: "mmsisdn",
                TrOnlyClassName: 'tsc',
                text: "Phone No.",
                className: "tsc",
                align: "left"
            },

            {
                key: "mproduct_id",
                TrOnlyClassName: 'tsc',
                text: "Product",
                className: "tsc",
                align: "left"
            },


            {
                key: "mactivation",
                TrOnlyClassName: 'tsc',
                text: "Activation",
                className: "tsc",
                align: "left"
            },


            {
                key: "m_activation",
                TrOnlyClassName: 'tsc',
                text: "Activation Time",
                className: "tsc",
                align: "left"
            },

            {
                key: "mbalance",
                TrOnlyClassName: 'tsc',
                text: "Status",
                className: "tsc",
                align: "left"
            },
            {
                key: "dates",
                TrOnlyClassName: 'tsc',
                text: "Date",
                className: "tsc",
                align: "left"
            },


        ];
        this.config = {
            key_column: "tsc",
            length_menu: [100, 200, 500],
            show_filter: false,
            show_pagination: false,
            pagination: 'advance',
            page_size: 100,
            show_length_menu: false,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No record was found today",
                filter: "Enter date (YYYY-MM-DD)",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                print: false,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showModal: false,
            showError: false,
            isShowError: false,
            mdata: 0,
            showComponent: false,
            queryString: "23401220000030392",
            hideComponent: false,
            terms_channel: [
                {
                    label: 'LUCKYBOX 1000',
                    value: '23401220000030403',
                },
                {
                    label: 'LUCKYBOX 500',
                    value: "23401220000030397"
                },
                {
                    label: 'LUCKYBOX 100',
                    value: '23401220000030393',
                },
                {
                    label: 'LUCKYBOX 50',
                    value: "23401220000030392"
                }
            ],
            terms_channel_two: [
                {
                    label: 'LUCKYBOX `100',
                    value: '23401220000030393',
                },
                {
                    label: 'LUCKYBOX 50',
                    value: "23401220000030392"
                }
            ],
            data: [],
        };
        let now = new Date();
        let start = moment.utc(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment.utc(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end,
            queryString: "23401220000030392",
            isPageLoad: true,
            terms_channel: [
                {
                    label: 'LUCKYBOX 1000',
                    value: '23401220000030403',
                },
                {
                    label: 'LUCKYBOX 500',
                    value: "23401220000030397"
                },
                {
                    label: 'LUCKYBOX 100',
                    value: '23401220000030393',
                },
                {
                    label: 'LUCKYBOX 50',
                    value: "23401220000030392"
                }
            ],
            terms_channel_two: [
                {
                    label: 'LUCKYBOX `100',
                    value: '23401220000030393',
                },
                {
                    label: 'LUCKYBOX 50',
                    value: "23401220000030392"
                }
            ],
            data: [],
            mactive: 0,
            minactive: 0
        }
    }

    componentDidMount() {

        this.setState({
            startDate: moment.utc(new Date()).format('DD MMM, YYYY'),
            endDate: moment.utc(new Date()).format('DD MMM, YYYY'),
            isPageLoad: true,
            valuedate: "Today"
        })

        this.getData(23401220000030392, moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }

    getData = (queryString, startDate, endDate) => {

        let url = baseURL + `secure_d?channel=${queryString}&startDate="${startDate}"&endDate="${endDate} 23:59"&${queryString} `;

        // alert(url)

        this.setState({
            isLoading: true,
        })
        const config = {
            headers: {
                'Authorization': TOKEN
            }
        };
        axios.all([
            axios.get(url, config),
        ]).then(axios.spread((branchResponse) => {
            this.setState({
                admins: branchResponse.data.data,
                mdata: branchResponse.data.total,

                mactive: branchResponse.data.active,
                minactive: branchResponse.data.inactive,
                mdata_in: branchResponse.data.total_in,
                mdata_out: branchResponse.data.total_out,
                isLoading: false,
            },
                function () {
                    var data = [];
                    if (this.state.admins.length > 0) {

                        // alert(JSON.stringify(this.state.admins))
                        for (let i = 0; i < this.state.admins.length; i++) {


                            let mail;

                            let mmsisdn;
                            let mbalance;
                            if (this.state.admins[i].msisdn == null) {
                                mmsisdn = { mmsisdn: "_" };
                            } else {
                                mmsisdn = { mmsisdn: this.state.admins[i].msisdn };
                            }


                            let mproduct_id;

                            if (this.state.admins[i].product_id === "23401220000030403") {
                                mproduct_id = { mproduct_id: "LUCKYBOX 1000" };

                            }
                            else if (this.state.admins[i].product_id === "23401220000030397") {
                                mproduct_id = { mproduct_id: "LUCKYBOX 500" };
                            } else if (this.state.admins[i].product_id === "23401220000030393") {
                                mproduct_id = { mproduct_id: "LUCKYBOX 100" };


                            } else {

                                mproduct_id = { mproduct_id: "LUCKYBOX 50" };
                            }

                            let m_activation;
                            if (this.state.admins[i].m_activation == null) {

                                m_activation = { m_activation: "_" };
                            } else {
                                m_activation = { m_activation: this.state.admins[i].activation_time };

                            }


                            let mactivation;
                            if (this.state.admins[i].activation_time == null) {
                                mactivation = { mactivation: "_" };
                            } else {
                                mactivation = { mactivation: this.state.admins[i].msisdn };
                            }

                            if (this.state.admins[i].status == null) {
                                mbalance = { mbalance: "_" };
                            } else {
                                mbalance = { mbalance: this.state.admins[i].status };
                            }

                            let date = { dates: moment.utc(this.state.admins[i].activation_time).format("DD-MMM-yyyy HH:mm:ss") };

                            data.push(Object.assign(mmsisdn, date, mproduct_id, m_activation, mactivation, mbalance, this.state.admins[i]));
                            this.setState({
                                data: data
                            })
                        }


                    } else {
                        this.setState({
                            data: data,
                            isLoading: false,

                        })
                    }
                }
            );
        }))
    }


    applyCallback(startDate, endDate) {

        localStorage.setItem("STARTDATE", startDate)
        localStorage.setItem("ENDDATE", endDate)
        let Sdate1 = moment.utc(startDate).format('DD MMM, YYYY');
        let Edate2 = moment.utc(endDate).format('DD MMM, YYYY');
        this.setState({
            valuedate: Sdate1 + " " + Edate2,
            startDate: Sdate1,
            isPageLoad: true,
            endDate: Edate2
        })

        this.getData(this.state.queryString, moment.utc(startDate).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(endDate).subtract(2, 'hours').format('YYYY-MM-DD'));
    }


    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(this.state.queryString, moment.utc(localStorage.getItem("STARTDATE")).format('YYYY-MM-DD'), moment.utc(localStorage.getItem("ENDDATE")).format('YYYY-MM-DD'))


    }

    getDataUpdate() {
        let queryString = ("filter_value=&page_number=0&page_size=10&sort_order=false")

        this.getData(23401220000030392, moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }

    handleChangeChannel = value => {
        if (value != null) {

            // alert(value.value)
            this.setState(
                {
                    channel: value.value,
                    channel_m: value.value,

                });
            this.getData(value.value, moment.utc(this.state.startDate).format('YYYY-MM-DD'), moment.utc(this.state.endDate).format('YYYY-MM-DD'));

        }

        else {
            this.setState(
                {
                    channel: "23401220000030392",
                });

        }
    }

    render() {
        let ranges = {
            "Today Only": [moment.utc(this.state.start), moment.utc(this.state.end)],
            "Yesterday Only": [
                moment.utc(this.state.start).subtract(1, "days"),
                moment.utc(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment.utc(this.state.start).subtract(3, "days"), moment.utc(this.state.end)],
            "5 Days": [moment.utc(this.state.start).subtract(5, "days"), moment.utc(this.state.end)],
            "1 Week": [moment.utc(this.state.start).subtract(7, "days"), moment.utc(this.state.end)],
            "2 Weeks": [moment.utc(this.state.start).subtract(14, "days"), moment.utc(this.state.end)],
            "1 Month": [moment.utc(this.state.start).subtract(1, "months"), moment.utc(this.state.end)],
            "1 Year": [moment.utc(this.state.start).subtract(1, "years"), moment.utc(this.state.end)]
        };
        let local = {
            "format": "YYYY-MM-DD",
            "sundayFirst": false
        }


        return (
            <div >
                < >
                    < Card >
                        <CardBody >
                            <h4>Secure D</h4><br />



                            <div className="col-md-4">

                                <Select
                                    isClearable
                                    options={this.state.terms_channel}
                                    // onInputChange={this.loadOptions}
                                    placeholder="Select Product (Default Luckybox 50)"
                                    autosize={true}
                                    onChange={this.handleChangeChannel}
                                    // isLoading={this.state.isLoading}
                                    // noOptionsMessage={() => 'nothing found'}
                                    // loadingMessage={() => 'searching...'}   //minor type-O here
                                    className="selected"
                                    menuPortalTarget={document.body}
                                    name="namffe"
                                /><br />
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="col-md-8">
                                        <div className="row">
                                            <div className="col-6">
                                                <DateTimeRangeContainer
                                                    ranges={ranges}
                                                    start={this.state.start}
                                                    end={this.state.end}
                                                    local={local}
                                                    applyCallback={this.applyCallback}>
                                                    <FormControl
                                                        id="formControlsTextB"
                                                        type="text"
                                                        value={this.state.valuedate}
                                                        label="Text"
                                                        placeholder="Filter by Date"
                                                    />
                                                </DateTimeRangeContainer>
                                            </div>
                                            <div className="col-6 float-left">

                                                <button className=" float-left btn btn-primary btn-sm" onClick={e => {
                                                    this.getDataUpdate();
                                                    this.setState({
                                                        startDate: moment.utc(new Date()).format('DD MMM, YYYY'),
                                                        endDate: moment.utc(new Date()).format('DD MMM, YYYY'),
                                                        valuedate: "Today"
                                                    })
                                                }} >Clear</button>
                                                {/* <input id="input" type="text" readOnly /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">

                             
                                    <h4>Total Secure D Customers <b>{this.state.mdata} </b></h4><br />
                                    <h4>Total Active Customers <b>{this.state.mactive} </b></h4><br />
                                    <h4>Total InActive Customers <b>{this.state.minactive} </b></h4><br />
                             
                                </div>
                            </div>
                            <div className="panel-body" >

                                <br />

                                <ReactDatatable
                                    config={this.config}
                                    records={this.state.data}
                                    columns={this.columns}
                                    dynamic={true}
                                    id="tsc"
                                    loading={this.state.isLoading}
                                    total_record={this.state.mdata}
                                    onChange={this.tableChangeHandler} />
                            </div>
                        </CardBody>

                    </Card>
                </>
            </div>

        )
    }
}